import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageSection from "components/PageSection";
import { Body1, BodyStrong1, Title2 } from "components/Typography";

const OurMission = () => {
    const { t } = useTranslation("careers");
    return (
        <PageSection
            className="relative z-10 bg-white"
            containerClass="flex flex-col items-center md:w-7/12 py-16 md:pb-32 lg:py-44"
        >
            <Title2 className="fade-in-scroll text-neutral-700 text-center mb-4">{t("mission.label")}</Title2>
            <BodyStrong1 className="fade-in-scroll text-center mb-12">{t("mission.tagline")}</BodyStrong1>
            <Body1 className="fade-in-scroll text-center">
                <Trans i18nKey="careers:mission.body" components={{ 1: <br />, 2: <br /> }} />
            </Body1>
        </PageSection>
    );
};

export default OurMission;
